import React, { useState, useEffect } from 'react';

import Carousel from 'react-material-ui-carousel';
import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Grid,
} from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import CarouselRow from './carouselRow';

import useStyles from './styles';

// import { parseDate } from '../../../utils/date';

const TeleauditCarousel = ({
  listImages, loading, setCurrentImage,
}) => {
  const styles = useStyles();
  const [tripletsList, setTripletsList] = useState([]);

  useEffect(() => {
    const triplets = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < listImages.length; i++) {
      const oneTriplet = [];
      const previousIndex = i === 0 ? listImages.length - 1 : i - 1;
      const nextIndex = i === listImages.length - 1 ? 0 : i + 1;
      oneTriplet[0] = listImages.length > 1 ? listImages[previousIndex] : undefined;
      oneTriplet[1] = listImages[i];
      oneTriplet[2] = listImages.length > 1 ? listImages[nextIndex] : undefined;
      triplets[i] = oneTriplet;
    }
    setTripletsList(triplets);
  }, [listImages]);

  const content = (triplet) => (
    <CarouselRow
      triplet={triplet}
      setCurrentImage={setCurrentImage}
      listImages={listImages}
    />
  );
  return (
  <div>
    <Grid>
      <Grid item xs={12}>
        <Carousel
          autoPlay={false}
          indicators={false}
          timeout={0}
          cycleNavigation={true}
          navButtonsAlwaysVisible={true}
          navButtonsAlwaysInvisible={false}
          PrevIcon={<ArrowBackIosIcon/>}
          NextIcon={<ArrowForwardIosIcon/>}
            navButtonsProps={{
              style: {
                // Deliberately left literal: this is a scrim over the audited
                // photo so the white arrows stay readable. Inverting it in dark
                // mode would wash out the icons.
                backgroundColor: 'rgba(0,0,0,0.5)',
                borderRadius: 50,
              },
            }}
          navButtonsWrapperProps={{
            style: {
              height: '100%',
              top: '0',
              bottom: '0',
              zIndex: 2,
            },
          }}
        >
        {loading ? (
          <Table>
            <TableBody>
              <TableRow>
                <TableCell colSpan={9} className={styles.progress}>
                  <CircularProgress />
                  <h4>Loading</h4>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        ) : tripletsList.map((triplet) => (
          <div style={{ padding: '40px' }} key={triplet.id}>
            {content(triplet)}
          </div>
        ))}
        </Carousel>
      </Grid>
    </Grid>
  </div>
  );
};

export default TeleauditCarousel;
